import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  pageType?: 'website' | 'article' | 'profile';
}

export const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'ضوء الخريج - وجهتك الأولى في رحلة التخصص',
  description = 'تعرف على منصة ضوء الخريج التي تساعد الطلاب السعوديين في اختيار التخصص الجامعي المناسب. حمل التطبيق واحصل على استشارات مهنية، مقارنة التخصصات، وحساب المعدل',
  keywords = 'تطبيق ضوء الخريج, اختيار التخصص الجامعي, حساب الموزونة, حساب المركبة, التخصصات, الجامعات السعودية, حساب المعدل الجامعي, استشارات التعليم, توجيه مهني',
  canonical = 'https://about.alkhreej.com/',
  ogImage = 'https://about.alkhreej.com/logo_1to1.png',
  pageType = 'website'
}) => {
  const fullTitle = title.includes('ضوء الخريج') ? title : `${title} | ضوء الخريج`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={pageType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="ضوء الخريج" />
      <meta property="og:locale" content="ar_SA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:url" content={canonical} />

      {/* Additional SEO */}
      <meta name="author" content="ضوء الخريج" />
      <meta name="robots" content="index, follow" />
      <meta property="fb:locale" content="ar_SA" />
    </Helmet>
  );
};